// FAMILY-EXT: персист фильтров доски в localStorage между F5.
// Ключ — per-board, чтобы при переключении досок не путались.
// Что сохраняем:
//   - filterUserIds   — массив id-ов отфильтрованных юзеров (по participants)
//   - filterLabelIds  — массив id-ов отфильтрованных меток
//   - filterText      — текстовый поиск
//   - showHiddenCards — 'no'|'yes'|'only'
//   - showOnlyActive  — boolean (фильтр "Только активные")

const STORAGE_KEY_PREFIX = 'family-board-filters:';

const keyFor = (boardId) => `${STORAGE_KEY_PREFIX}${boardId}`;

export const saveBoardFilters = (boardId, data) => {
  if (!boardId) return;
  try {
    window.localStorage.setItem(keyFor(boardId), JSON.stringify(data));
  } catch (e) {
    // localStorage может быть отключён / переполнен — нестрашно, фильтры
    // просто не сохранятся на эту сессию.
  }
};

export const loadBoardFilters = (boardId) => {
  if (!boardId) return null;
  try {
    const raw = window.localStorage.getItem(keyFor(boardId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed !== 'object' || parsed === null) return null;
    return parsed;
  } catch (e) {
    return null;
  }
};

export const clearBoardFilters = (boardId) => {
  if (!boardId) return;
  try {
    window.localStorage.removeItem(keyFor(boardId));
  } catch (e) {
    // ignore
  }
};
